import { onMounted } from 'vue';

export default function useScrollToLast(elRef, scrollToSelected, criteriaCheckbox) {
  onMounted(() => {
    /* istanbul ignore else */
    if (scrollToSelected && criteriaCheckbox.value?.length) {
      const lastSelected = criteriaCheckbox.value[criteriaCheckbox.value.length - 1];
      try {
        const optionEl = elRef.value?.querySelector(`[value="${lastSelected}"]`);
        optionEl?.scrollIntoView({ behavior: 'instant', block: 'center' });
      } catch (e) {
        console.warn('useScrollToLast', e); // eslint-disable-line no-console
      }
    }
  });
}
